module.exports = __webpack_public_path__ + "static/media/biaoge_02.82dc324f.jpg";